"use client";
import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { CLIENT_LIST } from "../../utils/other-component";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";

const ClientReviews = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[100px] max-lg:py-20 max-md:py-16 max-sm:py-12">
        <div className="flex items-center justify-center flex-col">
          <BlueTag center>Client Reviews</BlueTag>

          <h2 className="text-[64px] max-xl:text-6xl text-center max-lg:text-5xl max-md:text-4xl max-sm:text-3xl font-bold ff-jakarta leading-[120%]">
            What Readers Are Saying
          </h2>

          <div className="w-full max-w-[1140px] mx-auto mt-[50px] max-lg:mt-9 max-md:mt-5">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={35}
              loop={true}
              grabCursor={true}
              pagination={{ clickable: true }} // Pagination dots enabled
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {CLIENT_LIST.map((obj, i) => (
                <SwiperSlide key={i}>
                  <div className="border border-solid  border-[#241DB64D] py-6 bg-[#241DB61A] flex items-center justify-between flex-col w-full min-w-[357px] group max-[1320px]:min-w-[300px] h-[304px] rounded-2xl transition-all ease-linear duration-300 hover:bg-[#241DB6] hover:text-white">
                    <div className="flex items-center flex-col">
                      <img
                        src={obj.userImg}
                        alt="user"
                        width={96}
                        height={96}
                        className="w-full max-w-[96px] pointer-events-none mx-auto"
                      />
                      <Icons className="mt-2.5 sm:mt-3.5" icon={obj.rating} />
                      <p
                        className={`text-[#4B4B4B] text-base text-center group-hover:text-white leading-[150%] font-normal pt-[10px] ${
                          i === 1 ? "max-w-[249px]" : "max-w-[262px]"
                        }`}
                      >
                        {obj.description}
                      </p>
                    </div>
                    <p className="text-[#010101] text-xl font-bold group-hover:text-white text-center">
                      {obj.name}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientReviews;
